module.exports = __webpack_public_path__ + "1d040bd1491328ac3704a6c918f9fb57.pdf";